import SegmentedControl from "app/components/SegmentedControl/SegmentedControl";
import { BetslipListTypes } from "app/utils/const";
import cx from "classnames";
import { uniq } from "lodash";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import "./BetSlipTypesHeader.scss";

type Props = {
  isSinglesFlashActive: boolean;
  isMultiplesFlashActive: boolean;
  setSinglesFlashFlag: Function;
  setMultiplesFlashFlag: Function;
  betSlipList: Array<any>;
  setTab: Function;
  tab: string;
  eventIds: number[];
};

class BetSlipTypesHeader extends Component<Props> {
  getTabs = () => {
    const {
      isSinglesFlashActive,
      setSinglesFlashFlag,
      betSlipList,
      setTab,
      tab,
      isMultiplesFlashActive,
      setMultiplesFlashFlag,
    } = this.props;
    // make array of unique eventIds
    let uniqBets = uniq(this.props.eventIds);

    return [
      {
        title: (
          <span
            className={cx({
              orangeFlash: isSinglesFlashActive,
            })}
            onAnimationEnd={() => setSinglesFlashFlag()}
          >
            <FormattedMessage
              tagName="span"
              id="bet-betslip-singles"
              values={{
                numberOfBets: betSlipList.length,
              }}
            />
          </span>
        ),
        callback: () => setTab(BetslipListTypes.SINGLES),
        isActive: tab === BetslipListTypes.SINGLES,
        googleTagClickId: "BETSLIP_SINGLES",
        dlvEventName: "BETSLIP_SINGLES",
      },
      {
        title: (
          <span
            className={cx({
              orangeFlash: isMultiplesFlashActive,
            })}
            onAnimationEnd={() => setMultiplesFlashFlag()}
          >
            {/* if number of multiple bets (excluding legs) is greater than 1 display number of multiple bets */}
            {uniqBets.length > 1 ? (
              <FormattedMessage
                tagName="span"
                id="bet-betslip-multiples-number-of-bets"
                values={{
                  numberOfBets: uniqBets.length,
                }}
              />
            ) : (
              <FormattedMessage tagName="span" id="bet-betslip-multiples" />
            )}
          </span>
        ),
        callback: () => setTab(BetslipListTypes.MULTIPLES),
        isActive: tab === BetslipListTypes.MULTIPLES,
        googleTagClickId: "BETSLIP_MULTIPLES",
        dlvEventName: "BETSLIP_MULTIPLES",
      },
    ];
  };

  render() {
    return (
      <SegmentedControl tabs={this.getTabs()} tabTypes={BetslipListTypes} />
    );
  }
}

const mapStateToProps = state => ({
  isMultiplesFlashActive: state.multiplesBetSlipListModel.isOrangeFlashActive,
  isSinglesFlashActive: state.betSlipListModel.isOrangeFlashActive,
  betSlipList: state.betSlipListModel.betSlipList,
  eventIds: state.multiplesBetSlipListModel.eventIds,
});

const mapDispatchToProps = dispatch => ({
  setMultiplesFlashFlag: () =>
    dispatch.multiplesBetSlipListModel.setFlashFlag(),
  setSinglesFlashFlag: () => dispatch.betSlipListModel.setFlashFlag(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetSlipTypesHeader) as any;
